'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _EntypoIcon = require('../EntypoIcon');

var _EntypoIcon2 = _interopRequireDefault(_EntypoIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var iconClass = 'entypo-svgicon entypo--AircraftTakeOff';

var EntypoAircraftTakeOff = function EntypoAircraftTakeOff(props) {
    return _react2.default.createElement(
        _EntypoIcon2.default,
        _extends({ propClass: iconClass }, props),
        _react2.default.createElement('path', { d: 'M19.87,6.453c0.119,0.257,0.127,1.29-4.884,3.642l-4.913,2.306c-1.71,0.803-4.191,1.859-5.285,2.151c-0.766,0.204-1.497-0.316-1.497-0.316s-2.206-1.975-2.792-2.419c-0.585-0.444-0.535-0.67,0.215-0.91c0.467-0.149,3.13,0.493,4.265,0.78c1.339-0.8,2.562-1.486,3.141-1.798c-1.396-1.033-4.008-2.962-4.841-3.55c-0.799-0.565,0.01-0.768,0.01-0.768c0.368-0.099,1.162-0.228,1.562-0.144c2.721,0.569,7.263,2.071,7.611,2.186c0.832-0.436,2.128-1.092,2.922-1.465C17.459,5.174,19.711,6.111,19.87,6.453z' })
    );
};

exports.default = EntypoAircraftTakeOff;
module.exports = exports['default'];